import { Message, MessageBox } from "element-ui";
import aes from "./aes";

export default {
  format(time, format) {
    let t = new Date(time);
    let tf = function (i) {
      return (i < 10 ? "0" : "") + i;
    };
    return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
      switch (a) {
        case "yyyy":
          return tf(t.getFullYear());
        case "MM":
          return tf(t.getMonth() + 1);
        case "mm":
          return tf(t.getMinutes());
        case "dd":
          return tf(t.getDate());
        case "HH":
          return tf(t.getHours());
        case "ss":
          return tf(t.getSeconds());
      }
    });
  },
  deepCopyForFYB(origin) {
    const targetObj = origin.constructor === Array ? [] : {};
    for (let key in origin) {
      if (origin.hasOwnProperty(key)) {
        if (origin[key] && typeof origin[key] === "object") {
          targetObj[key] = origin[key].constructor === Array ? [] : {};
          targetObj[key] = this.deepCopyForFYB(origin[key]);
        } else {
          targetObj[key] = origin[key];
        }
      }
    }
    return targetObj;
  },
  formatDuring(mss) {
    let hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = (mss % (1000 * 60)) / 1000;
    return hours + " 小时 " + minutes + " 分钟 " + seconds + " 秒 ";
  },
  /**
   * 把秒转成天时分秒
   * @param {*} seconds 秒数
   * @param {*} format 格式 day：N天N时N分N秒；hour：N时N分N秒；minute：N分N秒；
   * @param {*} language 中英文 cn：N天N时N分N秒；否则：N:N:N:N
   * @param {*} padZero 是否自动补全0
   * @returns 
   */
  formatTime(seconds, format, language = 'cn', padZero = true) {
    if (typeof seconds !== 'number' && typeof seconds !== 'string') {
      throw new Error('The first argument must be a number or a string of numbers');
    }
    seconds = parseInt(seconds);
    var days = Math.floor(seconds / (24 * 60 * 60));
    seconds -= days * 24 * 60 * 60;
    var hours = Math.floor(seconds / (60 * 60));
    seconds -= hours * 60 * 60;
    var minutes = Math.floor(seconds / 60);
    seconds -= minutes * 60;
    if (padZero) {
      days = days < 10 ? '0' + days : days;
      hours = hours < 10 ? '0' + hours : hours;
      minutes = minutes < 10 ? '0' + minutes : minutes;
      seconds = seconds < 10 ? '0' + seconds : seconds;
    }
    var result = '';
    if (format === 'day') {
      result = language === 'cn' ? days + '天' + hours + '时' + minutes + '分' + seconds + '秒' : days + ':' + hours + ':' + minutes + ':' + seconds;
    } else if (format === 'hour') {
      result = language === 'cn' ? hours + '时' + minutes + '分' + seconds + '秒' : hours + ':' + minutes + ':' + seconds;
    } else if (format === 'minute') {
      result = language === 'cn' ? minutes + '分' + seconds + '秒' : minutes + ':' + seconds;
    }
    return result;
  },
  formatSeconds(value) {
    var secondTime = parseInt(value); // 秒
    var minuteTime = 0; // 分
    var hourTime = 0; // 小时
    if (secondTime >= 60) {
      minuteTime = parseInt(secondTime / 60);
      secondTime = parseInt(secondTime % 60);
      if (minuteTime >= 60) {
        hourTime = parseInt(minuteTime / 60);
        minuteTime = parseInt(minuteTime % 60);
      }
    }
    var result = "" + (parseInt(secondTime) < 10 ? "0" + parseInt(secondTime) : parseInt(secondTime));

    // if (minuteTime > 0) {
    result = "" + (parseInt(minuteTime) < 10 ? "0" + parseInt(minuteTime) : parseInt(minuteTime)) + ":" + result;
    // }
    // if (hourTime > 0) {
    result = "" + (parseInt(hourTime) < 10 ? "0" + parseInt(hourTime) : parseInt(hourTime)) + ":" + result;
    // }
    return result;
  },
  isEmp(str) {
    if (
      str === "" ||
      str === undefined ||
      str === null ||
      str === "undefined" ||
      str === "null" ||
      (typeof str === "object" && str.length !== undefined && str.length === 0) ||
      (typeof str === "object" && Object.keys(str).length === 0 && JSON.stringify(str) === "{}")
    ) {
      return true;
    }
    return false;
  },
  toast(msg, type, time = 2000, fn) {
    Message({
      message: msg,
      type: type,
      duration: time,
      onClose() {
        fn ? fn() : "";
      },
    });
  },
  newGuid() {
    let guid = "";
    for (let i = 1; i <= 16; i++) {
      let n = Math.floor(Math.random() * 36).toString(36);
      guid += n;
    }
    return guid;
  },
  getLoc(key) {
    let str = localStorage.getItem(key);
    return str ? JSON.parse(aes.decrypt(str)) : str;
  },
  setLoc(key, value) {
    localStorage.setItem(key, aes.encrypt(JSON.stringify(value)));
  },
  getUser(key) {
    let userInfo = this.getLoc("userInfo");
    return userInfo[key];
  },
  alertEl(title, msg) {
    return MessageBox.confirm(msg, title || "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    });
  },
  getNowDate(str) {
    let data = new Date();
    return this.format(data, str);
  },
  changeTimes(val) {
    let arr = [];
    for (let value of val) {
      arr.push(this.format(value, "yyyy-MM-dd"));
    }
    return arr.join();
  },
  delAndAddImg(arr, obj) {
    let boo = false,
      i = 0;
    for (let [index, item] of arr.entries()) {
      if (item.id === obj.id) {
        boo = true;
        i = index;
        break;
      }
    }
    if (boo) {
      arr.splice(i, 1);
    } else {
      arr.push(obj);
    }
    return arr;
  },
  transSize(limit) {
    if (limit === null) limit = 0;
    if (typeof limit === "string") {
      console.log(typeof limit);
      limit = parseFloat(limit);
    }
    let size = "";
    if (limit < 0.1 * 1024) {
      //小于0.1KB，则转化成B
      size = limit.toFixed(2) + "B";
    } else if (limit < 0.1 * 1024 * 1024) {
      //小于0.1MB，则转化成KB
      size = (limit / 1024).toFixed(2) + "KB";
    } else if (limit < 0.1 * 1024 * 1024 * 1024) {
      //小于0.1GB，则转化成MB
      size = (limit / (1024 * 1024)).toFixed(2) + "MB";
    } else {
      //其他转化成GB
      size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
    }

    let sizeStr = size + ""; //转成字符串
    let index = sizeStr.indexOf("."); //获取小数点处的索引
    let dou = sizeStr.substr(index + 1, 2); //获取小数点后两位的值
    if (dou == "00") {
      //判断后两位是否为00，如果是则删除00
      return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
    }
    return size;
  },
  arrIndexChange(arr, i, j) {
    arr[i] = arr.splice(j, 1, arr[i])[0];
    return arr;
  },

  formatStrOrArray(par) {
    let str = "";
    let list = [];
    if (typeof par === "object") {
      par.forEach((item) => {
        str += `${item.id}|${item.name},`;
      });
      str = str.substring(0, str.length - 1);
      return str;
    } else {
      let arr = par.split(",");
      arr.forEach((item) => {
        let a = item.split("|");
        let obj = {};
        obj.id = a[0];
        obj.name = a[1];
        list.push(obj);
      });
      return list;
    }
  },
  isEmpty(data) {
    if (
      data === "" ||
      data === undefined ||
      data === null ||
      data === "undefined" ||
      data === "null" ||
      (data.length !== undefined && data.length === 0) ||
      (Object.keys(data).length === 0 && JSON.stringify(data) === "{}")
    ) {
      return true;
    }
    return false;
  },
  checkFormValIsEmpty(dataStr) {
    let boo = false,
      msg = "",
      levelOneIndex = 0,
      levelTwoIndex = 0;
    levelOne: for (let [index, val] of dataStr.entries()) {
      if(val.type === "oneChoice" && typeof val.trueIndex !== 'number') {
        boo = true;
        levelOneIndex = index;
        msg = `请选择第${index + 1}题的答案`;
        break;
      }
      if ((val.value === "" && val.type !== "labelTextFixed") || val.topic === "") {
        boo = true;
        levelOneIndex = index;
        msg = `请输入第${index + 1}的题目`;
        break;
      } else if (val.type === "checkBox" && val.missedScore >= val.score) {
        boo = true;
        levelOneIndex = index;
        msg = `第${index + 1}题的漏选分值大于等于总分值`;
        break;
      } else {
        if (Object.prototype.hasOwnProperty.call(val, "chooseList") && val.type !== "judge") {
          for (let [indexs, vals] of val.chooseList.entries()) {
            if (vals.val === "") {
              boo = true;
              levelTwoIndex = indexs;
              msg = `请输入第${index + 1}题的第${indexs + 1}个选项`;
              break levelOne;
            }
          }
        }

        if (Object.prototype.hasOwnProperty.call(val, "judgeList") && val.type === "judge") {
          for (let [indexs, vals] of val.judgeList.entries()) {
            if (vals.val === "") {
              boo = true;
              levelTwoIndex = indexs;
              msg = `请输入第${index + 1}题的第${indexs + 1}个选项`;
              break levelOne;
            }
          }
        }
      }
    }
    return {
      msg,
      boo,
      levelOneIndex,
      levelTwoIndex,
    };
  },
  //判断是否两位小数
  checkFloatOneNum(str) {
    let reg = /^[0-9]{1,2}\.?([0-9])?$/;
    return !reg.test(str);
  },
  //判断是否正整数
  checkInter(str) {
    let reg = /(^[1-9]\d*$)/;
    return !reg.test(str);
  },
  getExcel(res, name) {
    let a = document.createElement("a");
    let blob = new Blob([res], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    let objectUrl = URL.createObjectURL(blob);
    a.href = objectUrl;
    a.download = name;
    a.click();
    // window.open(objectUrl, "_blank");
  },
  getTime(value) {
    if (value === undefined) return "";
    var secondTime = parseInt(value); // 秒
    var minuteTime = 0; // 分
    var hourTime = 0; // 小时
    if (secondTime > 60) {
      minuteTime = parseInt(secondTime / 60);
      secondTime = parseInt(secondTime % 60);
      if (minuteTime > 60) {
        hourTime = parseInt(minuteTime / 60);
        minuteTime = parseInt(minuteTime % 60);
      }
    }
    var result = "" + parseInt(secondTime) + "秒";
    if (minuteTime > 0) {
      result = "" + parseInt(minuteTime) + "分" + result;
    }
    if (hourTime > 0) {
      result = "" + parseInt(hourTime) + "小时" + result;
    }
    return result;
  },
  encryptObj(obj) {
    let o = {};
    Object.keys(obj).forEach((item) => {
      o[item] = aes.encrypt(obj[item]);
      // if (process.env.NODE_ENV !== "development") {
      //   o[item] = aes.encrypt(obj[item]);
      // } else {
      //   o[item] = obj[item];
      // }
    });
    return o;
  },
  decryptObj(obj) {
    let o = {};
    Object.keys(obj).forEach((item) => {
      o[item] = aes.decrypt(obj[item]);
      // if (process.env.NODE_ENV !== "development") {
      //   o[item] = aes.decrypt(obj[item]);
      // } else {
      //   o[item] = obj[item];
      // }
    });
    return o;
  },
  checkQusForm(arr) {
    let type = false
    let msg = ""
    console.log(arr)
    arr.map((res, index)=>{
      if(res.topic === '' && !type) {
        type = true
        msg = `请输入第${index + 1}个模块的题干`
        if(res.type === 'remarks')msg = `请输入备注说明`
      }
      if(res.type === "richText" && res.content === '') {
        type = true
        msg = `请输入富文本`
      }
      if((res.type === 'oneChoice' || res.type === 'checkBox') && res.chooseList.length > 0) {
        res.chooseList.map(ret=>{
          if(ret.val === '' && !type) {
            type = true
            msg = `请输入第${index + 1}个模块的选项名称`
          }
        })
      }
      if(res.showTips && (res.tips === '' || !res.tips)) {
        type = true
        msg = `请输入第${index + 1}个模块的题干说明`
        // msg = `请输入第${res.index}题题干说明`
      }
    })
    return {
      msg,
      boo: type,
    };
  },
  deepCopy(obj) {
    if (typeof obj !== "object" || obj === null || process.env.NODE_ENV === "dd") {
      return obj;
    }
    let copy = Array.isArray(obj) ? [] : {};
    Object.keys(obj).forEach((key) => {
      copy[key] = this.deepCopy(obj[key]);
    });
    return copy;
  },
  /**
   * 英文标点换中文
   * @repSign
   * @return s
  */
  repSign(s) {
    return s.replace(',', '，');
  },
  thousandSep(num) {
		if (num === null || num === undefined) return 0;
		return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
	},
};
